import { brandWordmarkSvg } from '@tsuzuri/templates';
import type { PropsWithChildren, ReactNode } from 'react';

function Wordmark() {
  return (
    <img
      className="brand-wordmark"
      src={`data:image/svg+xml,${encodeURIComponent(brandWordmarkSvg())}`}
      alt="うちのこばこ"
      width="162"
      height="33"
    />
  );
}

function Mark() {
  return <img className="mark" src="/app-icon.png" alt="" width="36" height="36" />;
}

export function Header() {
  return (
    <header className="site-header">
      <a className="logo" href="/" aria-label="うちのこばこ ホーム">
        <Mark />
        <Wordmark />
      </a>
      <nav aria-label="メインナビゲーション">
        <a href="/mockups">レイアウト見本</a>
        <a href="/print">印刷のしかた</a>
        <a href="/privacy">プライバシー</a>
        <a href="/support">サポート</a>
      </nav>
    </header>
  );
}

export function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-brand">
        <Mark />
        <div>
          <Wordmark />
          <span>絵も、声も、わが家のたからもの。</span>
        </div>
      </div>
      <nav aria-label="フッターナビゲーション">
        <a href="/mockups">レイアウト見本</a>
        <a href="/terms">利用規約</a>
        <a href="/privacy">プライバシーポリシー</a>
        <a href="/print">印刷ガイド</a>
        <a href="/support">サポート・お問い合わせ</a>
      </nav>
      <small>© 2026 うちのこばこ</small>
    </footer>
  );
}

export function Shell({ children }: PropsWithChildren) {
  return (
    <>
      <Header />
      {children}
      <Footer />
    </>
  );
}

export function PageHero({
  eyebrow,
  title,
  children,
}: PropsWithChildren<{ eyebrow: string; title: ReactNode }>) {
  return (
    <section className="page-hero">
      <p className="eyebrow">{eyebrow}</p>
      <h1>{title}</h1>
      {children}
    </section>
  );
}
